import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useDashboardFireRisk = defineStore(
	'dashboardFireRisk',
	() => {
		const showChartSection = ref(true)
		const showMapSection = ref(true)
		const showTableSection = ref(true)

		const daysBefore = ref(1)

		const selectedMonitoredAreasIds = ref<string[]>([])

		return {
			showChartSection,
			showMapSection,
			showTableSection,
			selectedMonitoredAreasIds,
			daysBefore,
		}
	},
	{
		persist: {
			storage: localStorage,
		},
	},
)
